export const CONTACT = [
  { name: "PHONE:", link: "#" },
  { name: "+92 347 9888699", link: "#" },
  { name: "WHATSAPP:", link: "#" },
  { name: "+92 349 5575850", link: "#" },
  { name: "EMAIL:", link: "#" },
  { name: "horecaffe2@gmail.com", link: "#" },
];

export const PRODUCTS = [
  { name: "Room furniture", link: "/products" },
  { name: "Lounge furniture", link: "/products" },
  { name: "Lobby furniture", link: "/products" },
  { name: "Auditorium Furniture", link: "/products" },
  { name: "Office furniture", link: "/products" },
  { name: "Restaurant indoor furniture", link: "/products" },
];

export const OPRODUCTS = [
  { name: "Cafeteria Furniture", link: "/products" },
  { name: "Pool furniture", link: "/products" },
  { name: "Beach furniture", link: "/products" },
  { name: "Garden furniture", link: "/products" },
  { name: "Street furniture", link: "/products" },
  { name: "Restaurant outdoor furniture", link: "/products" },
];

  export const OTPRODUCTS = [
    { name: "Shades", link: "/products" },
    { name: "Decorations", link: "/products" },
    { name: "Lightings", link: "/products" },
    { name: "Pots & Planters", link: "/products" },
    { name: "Linen", link: "/products" },
    { name: "Reupholstery", link: "/products"}, 
];

export const Icons = [
  { name: "FaLinkedin", link: "#" }, // Using FaLinkedin from Font Awesome
  { name: "FaTwitter", link: "#" }, // Using FaTwitter from Font Awesome
  { name: "FaFacebook", link: "#" }, // Using FaGithub from Font Awesome
  { name: "FaWhatsapp", link: "#" }, // This seems redundant, but I'll keep it consistent with the input data
  { name: "FaInstagram", link: "#" }, // Using FaInstagram from Font Awesome
];
